import { unmockedGraphQlOperationsStore } from "./shared/store";
export const fetchMockStore = new Map();
export const graphQlMockStore = new Map();
export const unmockedFetchCallsStore = new Set();
export const readCookies = new Map();
export const readLocalStorage = new Map();
export const readSessionStorage = new Map();
if (typeof afterEach === 'function' && !globalThis.__sdkAfterDataStore) {
    globalThis.__sdkAfterDataStore = true;
    afterEach(()=>{
        fetchMockStore.clear();
        graphQlMockStore.clear();
        unmockedFetchCallsStore.clear();
        readCookies.clear();
        readLocalStorage.clear();
        readSessionStorage.clear();
        unmockedGraphQlOperationsStore.clear();
    });
}

//# sourceMappingURL=store.js.map